import React from 'react';
import { Box } from '@apia/theme';
import { TResponsiveTableCellRendererProps } from '../types';

const AdditionalColumnDefaultRenderer = ({
  column,
  cell,
}: TResponsiveTableCellRendererProps) => {
  if (cell.rendererProps?.html) {
    return (
      <Box
        className={`${cell.className ?? ''} responsiveTable__additionalInfoItem`}
        id={cell.id}
        title={cell.title}
      >
        <Box as="strong">
          {column.label || column.title || column.name}
          {cell.children ? ':' : ''}
        </Box>{' '}
        <Box
          dangerouslySetInnerHTML={{
            __html: cell.children as string,
          }}
          className="html__container"
        />
      </Box>
    );
  }
  return (
    <Box
      className={`${cell.className ?? ''} responsiveTable__additionalInfoItem`}
      id={cell.id}
      title={cell.title}
    >
      <Box as="strong">
        {column.label || column.title || column.name}
        {cell.children ? ':' : ''}
      </Box>{' '}
      {cell.children}
    </Box>
  );
};

export default React.memo(AdditionalColumnDefaultRenderer);
